import { HttpClient } from '@/data/protocols/http'
import { AxiosHttpClient } from '@/infra/http'
import { AxiosHttpAuthClient } from '@/infra/http/axios-http-auth-client'
import { clearAuthData, redirectToLogin } from '@/data/services/login/login-service-utils'

export const makeHttpClient = (): HttpClient => new AxiosHttpClient()
export const makeHttpAuthClient = (): HttpClient => {
  return new AxiosHttpAuthClient(() => {
    console.log(
      '[HttpAuthClient] ❌ 401 Unauthorized detected, clearing auth and redirecting to login'
    )
    clearAuthData()
    redirectToLogin(window.location.href)
  })
}
